import * as React from 'react';

import { usePriceFilterHandlers } from './usePriceFilterHandlers';
import { FDealType, getRangeValue, getTermValue } from '../../../../../JsonQuery';
import { checkIsHotelsSearch } from '../../../../../JsonQuery/utils/checkIsHotelsSearch';
import { Price } from '../../../components/filters/Price';
import { useDealType } from '../../../utils/useDealType';
import { useFiltersContext } from '../../../utils/useFiltersContext';
import { useOfferType } from '../../../utils/useOfferType';

export const PriceContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useFiltersContext();
  const dealType = useDealType();
  const offerType = useOfferType();
  const price = getRangeValue('price')(jsonQuery);
  const isSquareMeterPrice = getTermValue('price_sm')(jsonQuery);
  const isDailyRent = dealType === FDealType.RentDaily;
  const isHotelSearch = checkIsHotelsSearch(jsonQuery);
  const defaultPriceLabel = isDailyRent && !isHotelSearch ? 'Цена за сутки' : 'Цена';

  const { showCorrectionHint, handlePriceMinChange, handlePriceMaxChange } = usePriceFilterHandlers({
    jsonQuery,
    dealType,
    onChange,
    onApply,
  });

  const handlePriceTypeChange = React.useCallback(
    (isSquareMeterPrice: boolean | null) => {
      onChange({ action: 'setPriceType', arguments: [isSquareMeterPrice] });
      onApply();
    },
    [onApply, onChange],
  );

  return (
    <Price
      dealType={dealType}
      offerType={offerType}
      price={price}
      defaultPriceLabel={defaultPriceLabel}
      isSquareMeterPrice={isSquareMeterPrice}
      showCorrectionHint={showCorrectionHint}
      onPriceMinChange={handlePriceMinChange}
      onPriceMaxChange={handlePriceMaxChange}
      onPriceTypeChange={handlePriceTypeChange}
    />
  );
};
